// Salesman State
import i18n from '@/i18n'

export default {
  fullSalesmanList: [],
  salesmanList: [],
  salesmanInfo: {},
  commissionList: [
    { text: i18n.t('No Commission'), value: 'No Commission' },
    { text: i18n.t('Revenue Commission'), value: 'Revenue Commission' },
    { text: i18n.t('Gross Profit Commission'), value: 'Gross Profit Commission' }
  ]
}
